<template>
  <div class="wrapper main-wrapper">
    <div class="navbar-top">
      <div class="nav-l">
        <div class="nav-top-item online">
          <img src="@/assets/images/systemicon/online.png" alt=""/>
          <span class="fwb fz16">{{ sitePublic.online_number }}</span>
        </div>
<!--        <div class="nav-top-item fz14 fw4 faq" @click="toPolicy">{{ $t("faq") }}</div>-->
<!--        <div class="nav-top-item fair fz14 fwb" @click="checkRoll">-->
<!--          {{ $t("fairnessVerification") }}-->
<!--          <img src="@/assets/images/systemicon/verify.png" alt=""/>-->
<!--        </div>-->
        <div class="nav-top-item"></div>
      </div>
      <div class="nav-r" ref="navrRef">
        <!-- <div class="langrage" @click="click"></div> -->
        <div class="social">
          <!--https://discord.gg/FVNmRqmv3K-->
          <a href="https://discord.gg/VMCxu96CD5" target="_blank" rel="noopener noreferrer">
            <svg
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                width="21" height="16" viewBox="0 0 21 16">
              <path class="cls-1" fill-rule="evenodd" fill="rgb(100, 114, 132)"
                    d="M17.799,1.354 C17.794,1.343 17.784,1.335 17.773,1.329 C16.412,0.705 14.976,0.260 13.501,0.005 C13.473,-0.000 13.446,0.013 13.432,0.038 C13.237,0.392 13.059,0.757 12.901,1.129 C11.311,0.888 9.693,0.888 8.103,1.129 C7.944,0.756 7.763,0.392 7.564,0.038 C7.550,0.013 7.523,0.001 7.495,0.005 C6.020,0.259 4.584,0.705 3.224,1.330 C3.212,1.335 3.203,1.343 3.196,1.353 C0.475,5.416 -0.270,9.380 0.095,13.294 C0.098,13.314 0.108,13.332 0.123,13.344 C1.707,14.517 3.479,15.412 5.363,15.992 C5.390,16.000 5.419,15.991 5.436,15.968 C5.841,15.416 6.200,14.834 6.508,14.224 C6.524,14.192 6.512,14.152 6.479,14.135 C6.477,14.134 6.474,14.133 6.472,14.132 C5.907,13.915 5.359,13.655 4.835,13.352 C4.803,13.333 4.792,13.291 4.811,13.260 C4.816,13.252 4.821,13.245 4.828,13.240 C4.939,13.158 5.047,13.073 5.154,12.985 C5.173,12.970 5.198,12.967 5.221,12.976 C8.655,14.544 12.373,14.544 15.766,12.976 C15.789,12.966 15.816,12.968 15.835,12.984 C15.941,13.073 16.051,13.158 16.160,13.240 C16.190,13.262 16.197,13.304 16.175,13.335 C16.169,13.341 16.163,13.348 16.156,13.352 C15.633,13.657 15.084,13.918 14.518,14.131 C14.483,14.144 14.466,14.183 14.479,14.217 C14.480,14.219 14.480,14.222 14.481,14.224 C14.795,14.830 15.154,15.413 15.552,15.967 C15.570,15.990 15.599,16.000 15.627,15.992 C17.514,15.414 19.289,14.519 20.874,13.344 C20.890,13.333 20.900,13.315 20.902,13.295 C21.340,8.770 20.170,4.839 17.799,1.354 ZM13.993,10.911 C12.959,10.911 12.107,9.962 12.107,8.797 C12.107,7.631 12.943,6.682 13.993,6.682 C15.052,6.682 15.896,7.640 15.879,8.796 C15.879,9.962 15.052,10.911 13.993,10.911 ZM7.021,10.911 C5.987,10.911 5.135,9.962 5.135,8.797 C5.135,7.631 5.971,6.682 7.021,6.682 C8.079,6.682 8.923,7.640 8.907,8.796 C8.907,9.962 8.072,10.911 7.021,10.911 Z"/>
            </svg>
          </a>
          <a href="https://t.me/skinroll_net" target="_blank" rel="noopener noreferrer">
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="70"
                height="58"
                viewBox="0 0 70 58"
                id="telegram-svg"
            >
              <path
                  id="telegram"
                  data-name="telegram"
                  class="cls-1"
                  d="M5.055,24.838q28.06-12.208,37.413-16.1C60.293,1.339,63.993.053,66.409,0.01a4.227,4.227,0,0,1,2.486.746,2.756,2.756,0,0,1,.912,1.735,11.326,11.326,0,0,1,.1,2.522c-0.962,10.133-5.143,34.723-7.268,46.073-0.892,4.8-2.667,6.413-4.381,6.57C54.529,58,51.7,55.2,48.093,52.835c-5.644-3.7-8.832-6-14.316-9.607-6.336-4.169-2.226-6.461,1.383-10.206,0.942-.98,17.363-15.895,17.674-17.247a1.289,1.289,0,0,0-.3-1.133,1.468,1.468,0,0,0-1.323-.129q-0.857.192-27.068,17.866-3.834,2.634-6.957,2.567c-2.286-.049-6.7-1.294-9.975-2.357C3.2,31.285,0,30.595.283,28.379q0.211-1.73,4.772-3.54h0Z"
              />
            </svg>
          </a>

          <a
              href="https://www.facebook.com/skinrollplay"
              target="_blank"
              rel="noopener noreferrer"
          >
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="74"
                height="154"
                viewBox="0 0 74 154"
                id="facebook-svg"
            >
              <path
                  id="facebook"
                  data-name="facebook"
                  class="cls-1"
                  d="M72.7,51.29H46.173V42.5c0-13.156,5.13-18.2,18.443-18.2,4.123,0,7.468.1,9.384,0.293V2.021A89.4,89.4,0,0,0,56.369,0C29.255,0,16.754,12.832,16.754,40.544V51.257H0V76.136H16.754V154H46.2V76.168H68.156Z"
              />
            </svg>
          </a>
        </div>
        <cDropDown
            v-model:visible="dropdownVisible"
            :trigger="['click']"
            :getPopupContainer="() => $refs.navrRef"
            dropdownPlacement="bottomLeft"
        >
          <template #title>
            <div class="langrage-inner" :class="{ 'is-loading': lanStore.isLoadingLanguage }">
              <img class="currentimg" :src="currentLangImg" alt=""/>
              <!-- &#9660; -->
              <div class="jb"></div>
              <!-- 加载状态指示器 -->
              <transition name="fade">
                <div v-if="lanStore.isLoadingLanguage" class="lang-loading-spinner"></div>
              </transition>
            </div>
          </template>
          <template #cmenus>
            <a-menu>
              <a-menu-item
                  v-for="lanitem in langList"
                  :key="lanitem.key"
                  :disabled="lanStore.isLoadingLanguage"
              >
                <div class="lang-item" @click="selected(lanitem)">
                  <img :src="lanitem.nationalFlag" alt=""/>
                  <span>{{ lanitem.lang }}</span>
                </div>
              </a-menu-item>
            </a-menu>
          </template>
        </cDropDown>
        <template v-if="u.isToken">
          <div class="siteinfo info" @click="showMsg" v-if="0">
            <img src="@/assets/images/systemicon/siteinfo.png" alt="站内信"/>
            <div class="noti-dot"></div>
          </div>
          <div class="siteinfo tui" @click="logout">
            <svg
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                width="20px"
                height="18px"
                viewBox="0 0 20 18"
                id="quit-svg"
            >
              <path
                  class="cls-1"
                  d="M19.723,9.661 C19.720,9.664 19.715,9.665 19.712,9.668 L16.051,13.285 C15.682,13.649 15.084,13.649 14.715,13.285 C14.346,12.920 14.346,12.330 14.715,11.966 L16.771,9.935 L6.497,9.935 C5.981,9.935 5.562,9.516 5.562,9.000 C5.562,8.484 5.981,8.065 6.497,8.065 L16.771,8.065 L14.715,6.034 C14.346,5.670 14.346,5.080 14.715,4.715 C15.084,4.351 15.682,4.351 16.051,4.715 L19.712,8.332 C19.715,8.335 19.720,8.336 19.723,8.339 C19.908,8.521 19.999,8.761 19.999,9.000 C19.999,9.239 19.908,9.479 19.723,9.661 ZM12.544,4.675 C12.022,4.675 11.598,4.257 11.598,3.740 L11.598,2.870 C11.598,2.318 11.150,1.870 10.598,1.870 L2.893,1.870 C2.341,1.870 1.893,2.318 1.893,2.870 L1.893,15.130 C1.893,15.682 2.341,16.130 2.893,16.130 L10.598,16.130 C11.150,16.130 11.598,15.682 11.598,15.130 L11.598,14.260 C11.598,13.743 12.022,13.325 12.544,13.325 C13.067,13.325 13.491,13.743 13.491,14.260 L13.491,16.000 C13.491,17.105 12.596,18.000 11.491,18.000 L2.000,18.000 C0.895,18.000 0.000,17.105 0.000,16.000 L0.000,2.000 C0.000,0.895 0.895,-0.000 2.000,-0.000 L11.491,-0.000 C12.596,-0.000 13.491,0.895 13.491,2.000 L13.491,3.740 C13.491,4.257 13.067,4.675 12.544,4.675 Z"
              />
            </svg>
          </div>
        </template>
      </div>
    </div>
    <div class="navbar">
      <div class="left">
        <div class="logo">
          <img src="@/assets/images/systemicon/logo.svg" alt=""/>
        </div>
        <div class="nav-list">
          <router-link
              :class="{ activeNavItem: u.navi == navitem.name }"
              class="nav-item link_a"
              :style="{
            '--bgi':
              u.navi == navitem.name
                ? 'url(' + navitem.selectedImagePath + ')'
                : 'url(' + navitem.imagePath + ')',
          }"
              :to="`/${$route.params.lang}/${navitem.path}`"
              v-for="(navitem, index) in navList"
              :key="navitem.path"
              @click="clickNav(navitem, index)"
              @mouseenter="u.currentNav = navitem.name"
              @mouseleave="u.currentNav = u.currentNav"
          >{{ $t(navitem.navTitle) }}
            <div :class="{ activeLine: u.navi == navitem.name }"></div>
          </router-link>
        </div>
      </div>
      <div ref="accountRef" class="account" v-if="u.isToken">
<!--        <img-->
<!--            class="gift-code-btn"-->
<!--            src="@/assets/images/navbar/gift-code.png"-->
<!--            alt="Gift Code"-->
<!--            @click="doGiftCode"-->
<!--        />-->
        <a-button class="cs-cus-btn btn fwb" @click="doRefill">
          {{ $t("refill") }}
          <template #icon>
            <img src="@/assets/images/systemicon/pay.png" alt=""/>
          </template>
        </a-button>
        <div class="user" @click="toMine">
          <div>
            <div class="u-name fz14 fw4">{{ userInfo.name }}</div>
            <!-- <div class="balance fz18 fwb">{{ parseFloat(userInfo.bean).toFixed(2) }}</div> -->
            <div class="my-funds" v-if="u.userInfo.coin > 0">
              <a-tooltip placement="bottom">
                <template #title>
                  <div class="coin-tooltip">{{ $t('pendingCoinTip') }} {{ parseFloat(u.userInfo.coin).toFixed(2) }}</div>
                </template>
                <div class="funds-row">
                  <div class="funds-wp" @click.stop="doRefill">
                    <img class="funds-icon" src="@/assets/images/bank/gem-y.png" alt="">
                    <span class="funds gem fz18 fwb">{{ parseFloat(bean.gem).toFixed(2) }}</span>
                  </div>
                  <div class="funds-wp">
                    <img class="funds-icon" src="@/assets/images/bank/account.png" alt="">
                    <span class="balance fz18 fwb">{{ parseFloat(bean.num).toFixed(2) }}</span>
                  </div>
                </div>
              </a-tooltip>
            </div>
            <div class="my-funds" v-else>
              <div class="funds-wp" @click.stop="doRefill">
                <img class="funds-icon" src="@/assets/images/bank/gem-y.png" alt="">
                <span class="funds gem fz18 fwb">{{ parseFloat(bean.gem).toFixed(2) }}</span>
              </div>
              <div class="funds-wp">
                <img class="funds-icon" src="@/assets/images/bank/account.png" alt="">
                <span class="balance fz18 fwb">{{ parseFloat(bean.num).toFixed(2) }}</span>
              </div>
            </div>
            <!-- 减去 -->
            <div class="updateAccount">
              <span class="balance1">{{ updateStr }}</span>
            </div>
            <div class="updateBankAccount">
              <span class="balance1">{{ updateBankStr }}</span>
            </div>
            <div class="updateGemAccount">
              <span class="balance1">{{ updateGemStr }}</span>
            </div>
          </div>
          <div
              class="avatar-wp"
              :style="{ 'border-color': useDynamicLevelColor(userInfo.level || 1) }"
          >
            <img :src="$dimg(userInfo.avatar)" alt=""/>
            <div
                class="level"
                :style="{ 'background-color': useDynamicLevelColor(userInfo.level || 1) }"
            >
              {{ userInfo.level || 1 }}
            </div>
          </div>
        </div>
      </div>
      <div v-else class="account guest-account">
<!--        <img-->
<!--            class="gift-code-btn"-->
<!--            src="@/assets/images/navbar/gift-code.png"-->
<!--            alt="Gift Code"-->
<!--            @click="doGiftCode"-->
<!--        />-->
        <a-button class="login" @click="login">
          {{ $t("loginLarge") }}
          <template #icon v-if="!u.sandbox">
            <!-- <img src="@/assets/images/index/login_steam.png" alt="" /> -->
          </template>
        </a-button>
      </div>
    </div>
    <!-- Gift Code 兑换弹窗 -->
    <myModal
        class="gift-code-modal"
        :width="'5rem'"
        :centered="true"
        :visible="showGiftCode"
        @close="closeGiftCode"
    >
      <template #cuscloseIcon>
        <img src="@/assets/images/systemicon/close.png" alt=""/>
      </template>
      <template #body>
        <div class="gift-code-container">
          <div class="gift-code-title">GIFT CODE</div>
          <div class="gift-code-subtitle">{{ $t("enterCdKey") }}</div>
          <div class="gift-code-input-wrap">
            <a-input
                v-model:value="giftCodeValue"
                :placeholder="$t('inputGiftCode')"
                class="gift-code-input"
                @pressEnter="handleClaim"
            />
          </div>
          <a-button
              class="gift-code-claim"
              :disabled="!giftCodeValue || giftCodeLoading"
              :loading="giftCodeLoading"
              @click="handleClaim"
          >{{ $t("claim") }}
          </a-button>
        </div>
      </template>
    </myModal>

    <div class="user-card" v-show="isShowUserCard">
      <div class="account" v-if="u.isToken">
<!--        <img-->
<!--            class="gift-code-btn"-->
<!--            src="@/assets/images/navbar/gift-code.png"-->
<!--            alt="Gift Code"-->
<!--            @click="doGiftCode"-->
<!--        />-->
        <a-button class="cs-cus-btn btn fwb" @click="doRefill">
          {{ $t("refill") }}
          <template #icon>
            <img src="@/assets/images/systemicon/pay.png" alt=""/>
          </template>
        </a-button>
        <div class="user" @click="toMine">
          <div>
            <div class="u-name fz14 fw4">{{ userInfo.name }}</div>
            <!-- <div class="balance fz18 fwb">{{ parseFloat(userInfo.bean).toFixed(2) }}</div> -->
            <a-tooltip placement="bottom" v-if="u.userInfo.coin > 0">
              <template #title>
                <div class="coin-tooltip">{{ $t('pendingCoinTip') }} {{ parseFloat(u.userInfo.coin).toFixed(2) }}</div>
              </template>
              <div class="funds-row">
                <img class="funds-icon" src="@/assets/images/bank/gem-y.png" alt="">
                <span class="gem fz18 fwb">{{ parseFloat(bean.gem).toFixed(2) }}</span>
                <img class="funds-icon" src="@/assets/images/bank/account.png" alt="">
                <span class="balance fz18 fwb">{{ parseFloat(bean.num).toFixed(2) }}</span>
              </div>
            </a-tooltip>
            <div class="funds-row" v-else>
              <img class="funds-icon" src="@/assets/images/bank/gem-y.png" alt="">
              <span class="gem fz18 fwb">{{ parseFloat(bean.gem).toFixed(2) }}</span>
              <img class="funds-icon" src="@/assets/images/bank/account.png" alt="">
              <span class="balance fz18 fwb">{{ parseFloat(bean.num).toFixed(2) }}</span>
            </div>
            <!-- 减去 -->
            <div class="updateAccount">
              <span class="balance1">{{ updateStr }}</span>
            </div>
            <div class="updateAccount">
              <span class="balance1">{{ updateGemStr }}</span>
            </div>
          </div>
          <div
              class="avatar-wp"
              :style="{ 'border-color': useDynamicLevelColor(userInfo.level || 1) }"
          >
            <img :src="$dimg(userInfo.avatar)" alt=""/>
            <div
                class="level"
                :style="{ 'background-color': useDynamicLevelColor(userInfo.level || 1) }"
            >
              {{ userInfo.level || 1 }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import eventEmitter from "@/utils/emitter.js";
import i18n from "@/i18n";

const {t: $t, locale} = i18n.global;
import {useLangStore} from "@/store/module/i18n.js";
import {
  ref,
  getCurrentInstance,
  nextTick,
  h,
  watch,
  onMounted,
  reactive,
  computed,
  watchEffect,
  onBeforeUnmount,
} from "vue";
import {useDynamicLevelColor} from "@/hook/useLevelColor.js";
import isBalanceEnough from "@/utils/isBalanceEnough.js";
import getAccountBalance from "@/utils/getAccountBalance.js";
import nationImgModal from "@/utils/dynamicImg.js";
import cDropDown from "@/components/common/dropdown/index.vue";
import $api from "@/api";
import $store from "@/store";
import {storeToRefs} from "pinia";
// import { loginModal } from "@/components/common/login/fnlogin.js";
import {loginModal} from "@/components/common/login";

import {useRouter, useRoute} from "vue-router";
// 语言包 - 已移除，使用懒加载方式
// import langPkg from "@/i18n/locales";  // ❌ 已删除此行，避免一次性加载所有语言包
import ColumnGroup from "ant-design-vue/lib/vc-table/sugar/ColumnGroup";
import {notification} from "ant-design-vue";
import {SmileOutlined} from "@ant-design/icons-vue";
import {getImageUrlByNewURL} from "@/utils/getImageUrl.js";
import {gsap} from "gsap";
import computeNumber from "@/utils/calcTotal.js";

//userStore
const u = $store("user");
const siteStore = $store("siteInfo");
const isSandbox = ref(false);
const {sitePublic} = storeToRefs(siteStore);
const {userInfo} = storeToRefs(u);
const bean = reactive({
  // num:userInfo.bean
  num: u.userInfo.bean || 0,
  gem: u.userInfo.gem || 0,
});
const stimer = setTimeout(() => {
  clearTimeout(stimer);
  console.log("sandbox:", localStorage.getItem("sandbox"));
  isSandbox.value = localStorage.getItem("sandbox") === "true";
  console.log("issandbox:", isSandbox.value);
  u.sandbox = isSandbox.value;
}, 1000);
watch(
    () => u.userInfo.bean,
    (newval, oldval) => {
      gsap.to(bean, {
        duration: 0.5,
        num: newval,
        onComplete() {
          // console.log("ddd;", u.userInfo.bean);
        },
      });
    }
);
watch(
    () => u.userInfo.gem,
    (newval, oldval) => {
      gsap.to(bean, {
        duration: 0.5,
        gem: newval,
        onComplete() {
          // console.log("ddd;", u.userInfo.bean);
        },
      });
    }
);

const router = useRouter();
const route = useRoute();

//View the dice roll
function checkRoll(roll_id) {
  router.push(`/${route.params.lang}/seed`);
}

// const { t:$t, locale } = i18n.global;
const lanStore = useLangStore();
const locLang = ref(lanStore.language);
//js中获取当前语言
// console.log('lanL:',i18n.global.t('login'));
// console.log('$t lanL:',$t('login'));
// console.log('lanL:',i18n.global.t('login'));
// console.log('lanL:',i18n.global.t('loginobj'));
const {proxy} = getCurrentInstance();

const updateCount = ref({type: "increment", val: 0, paytype: false});
const updateBankCount = ref({type: "increment", val: 0, paytype: false});
const updateGemCount = ref({type: "increment", val: 0, paytype: false});
const updateStr = computed(() => {
  let type = "";
  switch (updateCount.value.type) {
    case "increment":
      type = "+";
      break;
    case "decrement":
      type = "-";
      break;
  }
  return type + "$ " + updateCount.value.val;
});
const updateBankStr = computed(() => {
  let type = "";
  switch (updateBankCount.value.bankType) {
    case "increment":
      type = "+";
      break;
    case "decrement":
      type = "-";
      break;
  }
  return type + "$ " + updateBankCount.value.val;
});
const updateGemStr = computed(() => {
  let type = "";
  switch (updateGemCount.value.type) {
    case "increment":
      type = "+";
      break;
    case "decrement":
      type = "-";
      break;
  }
  return type + "$ " + updateGemCount.value.val;
});

function updAccount(params) {

  //宝石更新余额
  if (params.gem) {
    updateGemCount.value = params;
    //短时间内多次执行扣费动画 如何优化
    gsap.from(".updateGemAccount", {
      y: 20,
      duration: 1.2,
      opacity: 1,
      delay: 0.1,
      onComplete() {
        // console.log("扣费结束");
        gsap.set(".updateGemAccount", {y: 0, opacity: 0});
      },
    });
    //银行账户更新
    getAccountBalance(params.type === 'increment' ? 'addGem' : 'subGem', u, params.val);
    return;
  }

  //更新头部银行余额,因需求调整,显示为皮肤充值金额,故以下更新银行余额的代码不用,return终止执行
  if('skinsPay'===params.type){
    // return;
    // if(params.bank){
    //   updateBankCount.value = params;
    //   //短时间内多次执行扣费动画 如何优化
    //   gsap.from(".updateBankAccount", {
    //     y: 20,
    //     duration: 1.2,
    //     opacity: 1,
    //     delay: 0.1,
    //     onComplete() {
    //       // console.log("扣费结束");
    //       gsap.set(".updateBankAccount", {y: 0, opacity: 0});
    //     },
    //   });
    //   //银行账户更新
    //   getAccountBalance(params.bankType==='increment'?'addBank':'subBank', u, params.val);
    // }
    // return;
  }
  //isBalanceEnough  返回payType的值金币或钻石;余额不足则返回false--在false处处理余额不足问题
  const paytype = params.paytype ? params.paytype : isBalanceEnough(u, proxy, params.val);
  if (!paytype) {
    //noEnough 余额不足
    u.noEnough = true;
    // proxy.$EventBus.emit("noEnough", { type: "noEnough" });
    doRefill();
    return console.log("余额不足,前往充值页面");
  }
  console.log("paytype:", paytype, params);

  updateCount.value = params;
  //短时间内多次执行扣费动画 如何优化
  gsap.from(".updateAccount", {
    y: 20,
    duration: 1.2,
    opacity: 1,
    delay: 0.1,
    onComplete() {
      // console.log("扣费结束");
      gsap.set(".updateAccount", {y: 0, opacity: 0});
    },
  });

  getAccountBalance(paytype, u, params.val);

  // 更新头部银行余额,因需求调整,显示为皮肤充值金额,故以下更新银行余额的代码不用,return终止执行
  if(params.bank){
    // return;
    // updateBankCount.value = params;
    // //短时间内多次执行扣费动画 如何优化
    // gsap.from(".updateBankAccount", {
    //   y: 20,
    //   duration: 1.2,
    //   opacity: 1,
    //   delay: 0.1,
    //   onComplete() {
    //     // console.log("扣费结束");
    //     gsap.set(".updateBankAccount", {y: 0, opacity: 0});
    //   },
    // });
    // //银行账户更新
    // getAccountBalance(params.bankType==='increment'?'addBank':'subBank', u, params.val);
  }

}



proxy.$EventBus.on("upd", updAccount);


//测试并发扣费
// const isClick = ref(false);
// function testDeduction() {
//   console.log("扣除");
//   if (isClick.value) return;
//   isClick.value = true;
//   proxy.$EventBus.emit("upd", { type: "decrement", val: 100 });
//   gsap.delayedCall(1, () => {
//     isClick.value = false;
//   });
// }

const noticeCount = ref(0);

//测试全局提示
function showMsg() {
  // console.log("test all tips");
  proxy.$notice("s", {
    desc:
        "This is the content of the notification.This is the content of the notification.This is the content of the notification.This is the content of the notification.",
  });
  // notification.error({
  //   placement:'bottomLeft',
  //   class: "cus-err",
  //   key:noticeCount.value,
  //   message: "title"+noticeCount.value,
  //   description: "This is the content of the notification. ",
  //   onClose:()=>{
  //     console.log('notice is close');
  //   },
  //   icon: () =>
  //     h("img", {
  //       src: getImageUrlByNewURL("systemicon/notice_error.png"),
  //       style: "color: #108ee9",
  //       class: "notice-icon",
  //     }),
  // });
  // noticeCount.value++;
}

// watch(
//   () => noticeCount.value,
//    () => {
//     nextTick(()=>{
//       console.log('count;',noticeCount.value);
//       const cusErrLen = document.getElementsByClassName("cus-err");

//       //watch dom.length
//       console.log("cuserrlen;", cusErrLen);
//       console.log("len:", cusErrLen.length);
//       console.log('html;',cusErrLen[cusErrLen.length-1]);

//     })
//   }
// );

function toPolicy() {
  // console.log("跳转常见问题解答");
  // return
  const val = {id: 2};
  router.push(`/${route.params.lang}/policy/${val.id}`);
}

//可使用的语言
const langList = ref({});
// ❌ 已删除：for (const key in langPkg) langList.value[key] = key;
// 不再从 langPkg 导入，直接使用下面的 langArr 定义

//语言相关配置
const langArr = [
  {
    key: "en",
    lang: "ENGLISH",
    // nationalFlag: proxy.$getImageUrlByNewURL("systemicon/nationalflag/en-gb.svg"),
  },
  {
    key: "de",
    lang: "Deutsch",
    // nationalFlag: proxy.$getImageUrlByNewURL("systemicon/nationalflag/zh-cn.png"),
  },
  {
    key: "pl",
    lang: "Polski",
    // nationalFlag: proxy.$getImageUrlByNewURL("systemicon/nationalflag/zh-cn.png"),
  },
  {
    key: "es",
    lang: "Español ",
    // nationalFlag: proxy.$getImageUrlByNewURL("systemicon/nationalflag/zh-cn.png"),
  },
  {
    key: "pt",
    lang: "Português ",
    // nationalFlag: proxy.$getImageUrlByNewURL("systemicon/nationalflag/zh-cn.png"),
  },
  {
    key: "ru",
    lang: "Русский",
  },
  {
    key: "tr",
    lang: "Türkçe ",
    // nationalFlag: proxy.$getImageUrlByNewURL("systemicon/nationalflag/zh-cn.png"),
  },
  {
    key: "br",
    lang: "BRAZIL ",
    // nationalFlag: proxy.$getImageUrlByNewURL("systemicon/nationalflag/zh-cn.png"),
  },
  {
    key: "zh-CN",
    lang: "简体中文",
    // nationalFlag: proxy.$getImageUrlByNewURL("systemicon/nationalflag/zh-cn.png"),
  },
  {
    key: "zh-TW",
    lang: "繁体中文",
    // nationalFlag: proxy.$getImageUrlByNewURL("systemicon/nationalflag/zh-cn.png"),
  },
  {
    key: "idn",
    lang: "INDONESIA ",
  },
  {
    key: "th",
    lang: "ไทย ",
  },
  {
    key: "vn",
    lang: "Tiếng Việt  ",
    // nationalFlag: proxy.$getImageUrlByNewURL("systemicon/nationalflag/zh-cn.png"),
  },
  {
    key: "fr",
    lang: "Français",
    // nationalFlag: proxy.$getImageUrlByNewURL("systemicon/nationalflag/zh-cn.png"),
  },
  {
    key: "jp",
    lang: "日本語 ",
    // nationalFlag: proxy.$getImageUrlByNewURL("systemicon/nationalflag/zh-cn.png"),
  },
  {
    key: "kr",
    lang: "한국어 ",
    // nationalFlag: proxy.$getImageUrlByNewURL("systemicon/nationalflag/zh-cn.png"),
  },
];
for (const obj of langArr) {
  // console.log("key:", obj.key);
  for (const key in nationImgModal) {
    if (key == obj.key) {
      obj.nationalFlag = nationImgModal[key];
    }
  }
}
//根据系统语言包,生成最终需要的语言相关数据,供给用户选择要使用的语言
// ✅ 直接从 langArr 构建 langList，不再依赖 langPkg
langArr.forEach((e) => {
  langList.value[e.key] = e;
});
const currentLangImg = ref();
// ✅ 控制下拉菜单的显示状态
const dropdownVisible = ref(false);
// console.log("langlist after:", langList.value);

// ⭐ 语言码归一：后端 /getLang 返回的是 Cloudflare 国家码（gb/us/au...），
// 本端 localStorage 里也可能存着 gb / en-gb，直接拿去匹配语言表会全部落空（头部国旗不显示）
const langAlias = {
  gb: 'en', uk: 'en', 'en-gb': 'en', us: 'en', au: 'en', ca: 'en', ie: 'en', nz: 'en',
  cn: 'zh-CN', sg: 'zh-CN', 'zh-cn': 'zh-CN', tw: 'zh-TW', hk: 'zh-TW', 'zh-tw': 'zh-TW',
  // 站内口径：id / in 都是印尼语（in 为旧 ISO 639-1 码），统一归到本站 key idn
  ja: 'jp', ko: 'kr', vi: 'vn', 'pt-br': 'br',
  id: 'idn', 'id-id': 'idn', in: 'idn', 'in-id': 'idn',
}
const rawLang = String(lanStore.language || '').trim()
const flagLangKey = langAlias[rawLang.toLowerCase()] || (langList.value[rawLang] ? rawLang : 'en')
const flagItem = langList.value[flagLangKey]
if (flagItem && flagItem.nationalFlag) {
  currentLangImg.value = flagItem.nationalFlag
}
// currentLangImg.value = langList.value.filters((v) => {
//   if (lanStore.language == v.key) {
//     return v.nationalFlag;
//   } else {
//     return langArr.filter((v) => {
//       if (v.key == "en") {
//         return v.nationalFlag;
//       }
//     });
//   }
// });

// console.log("dangqian:", lanStore.language);
//切换语言

const selected = async (lanitem) => {
  // 如果正在加载，忽略点击
  if (lanStore.isLoadingLanguage) {
    return;
  }

  // 如果是当前语言，直接返回
  if (lanStore.language === lanitem.key) {
    dropdownVisible.value = false;  // ✅ 关闭下拉菜单
    return;
  }

  console.log("cL:", lanitem);
  currentLangImg.value = lanitem.nationalFlag;

  // ✅ 立即关闭下拉菜单（不等待加载完成）
  dropdownVisible.value = false;

  try {
    // 异步加载语言包
    await lanStore.changeLang(lanitem.key);

    // 语言加载成功后再跳转
    router.push({
      params: {lang: lanitem.key},
      query: {
        ...route.query, // 保留所有当前查询参数
      }
    });
  } catch (error) {
    console.error('语言切换失败:', error);
    // 错误提示（如果存在的话）
    if (proxy.$cmessage) {
      proxy.$cmessage('error', {
        message: '语言切换失败，请重试'
      });
    } else if (proxy.$notice) {
      proxy.$notice('f', { desc: '语言切换失败，请重试' });
    } else {
      // 降级方案：使用浏览器原生提示
      console.error('语言切换失败，请刷新页面重试');
    }
  }
};

//监听底部语言切换,切换导航栏语言图标
eventEmitter.on("lang:change", (params) => {
  console.log("lang:change:", params);
  currentLangImg.value = langList.value[params].nationalFlag;
});

//监听地址栏语言切换,切换页面语言和语言旗帜
eventEmitter.on("update:lang", (params) => {
  lanStore.changeLang(params);
});

// proxy.$EventBus.on("langChange", (params) => {
//   console.log("langChange:", params);
//   return
//   currentLangImg.value = langList.value[params].nationalFlag;
//   lanStore.changeLang(params);
// });

//切换语言
const click = () => {
  // console.log("click");
  if (locLang.value == "en") {
    locLang.value = "zh-CN";
  } else {
    locLang.value = "en";
  }
  lanStore.changeLang(locLang.value);
};

//导航栏数据 $myt
const navList = ref([
  {
    navTitle: "navBox",
    imagePath: proxy.$getImageUrlByNewURL("systemicon/navicon/box.png"),
    selectedImagePath: proxy.$getImageUrlByNewURL("systemicon/navicon/boxSelected.png"),
    path: "box",
    name: "box",
    checked: true,
  },
  {
    navTitle: "navBattle",
    imagePath: proxy.$getImageUrlByNewURL("systemicon/navicon/battle.png"),
    selectedImagePath: proxy.$getImageUrlByNewURL(
        "systemicon/navicon/battleSelected.png"
    ),
    path: "battle",
    name: "battle",
    checked: false,
  },
  // {
  //   navTitle: "navRoll",
  //   imagePath: proxy.$getImageUrlByNewURL("systemicon/navicon/roll.png"),
  //   selectedImagePath: proxy.$getImageUrlByNewURL("systemicon/navicon/rollSelected.png"),
  //   path: "/roll",
  //   name: "roll",
  //   checked: false,
  // },
  {
    navTitle: "navUpgrade",
    imagePath: proxy.$getImageUrlByNewURL("systemicon/navicon/contract.png"),
    selectedImagePath: proxy.$getImageUrlByNewURL(
        "systemicon/navicon/contractSelected.png"
    ),
    path: "upgrade",
    name: "upgrade",
    needLogin: true,
    checked: false,
  },

  {
    navTitle: "navExchange",
    imagePath: proxy.$getImageUrlByNewURL("systemicon/navicon/exchange.png"),
    selectedImagePath: proxy.$getImageUrlByNewURL(
        "systemicon/navicon/exchangeSelected.png"
    ),
    path: "exchange",
    name: "exchange",
    needLogin: true,
    checked: false,
  },
  {
    navTitle: "navGift",
    imagePath: proxy.$getImageUrlByNewURL("systemicon/navicon/dailycase.png"),
    selectedImagePath: proxy.$getImageUrlByNewURL(
        "systemicon/navicon/dailycaseSelected.png"
    ),
    path: "daily",
    name: "daily",
    checked: false,
  },
  {
    navTitle: "navMission",
    imagePath: proxy.$getImageUrlByNewURL("systemicon/navicon/mission.png"),
    selectedImagePath: proxy.$getImageUrlByNewURL(
        "systemicon/navicon/missionSelected.png"
    ),
    path: "mission",
    name: "mission",
    checked: false,
  },
  // {
  //   navTitle: "navBank",
  //   imagePath: proxy.$getImageUrlByNewURL("systemicon/navicon/bank.png"),
  //   selectedImagePath: proxy.$getImageUrlByNewURL(
  //       "systemicon/navicon/bankSelected.png"
  //   ),
  //   path: "bank",
  //   name: "bank",
  //   checked: false,
  // },
]);

watch(
    () => router.currentRoute.value.name,
    (toname) => {
      //要执行的方法
      // console.log("router.currentRoute", router.currentRoute.value.name);
      const nl = navList.value.some((v) => {
        return v.name == toname;
      });
      if (!nl) {
        //路由不包含导航栏的路径,直接返回
        u.navi = 0;
        return;
      }

      u.navi = router.currentRoute.value.name;
      // console.log("navi:", u.navi);
    },
    {immediate: true, deep: true}
);

//选中导航栏
const clickNav = (navitem, index) => {
  console.log("navitem:", navitem, "index:", index);
  if (u.navi == index) return;
  if (navitem.needLogin && !u.isLogin) {
    return;
  }
  u.navi = navitem.name;
  u.currentNav = navitem.name;
  if (navitem.checked) return;
  // console.log("current navlist:", navitem.path);
  navitem.checked = true;
  navList.value.map((v) => {
    if (v.path != navitem.path) {
      v.checked = false;
    }
  });
};

//悬浮导航栏
function mouseenterNav(navitem, index) {
  // console.log("悬浮导航栏", navitem, index);
}

//充值
function doRefill() {
  // console.log("个人中心充值");
  eventEmitter.emit("api:no_enough");
}

// === Gift Code 兑换 ===
const showGiftCode = ref(false);
const giftCodeValue = ref("");
const giftCodeLoading = ref(false);

function doGiftCode() {
  if (!u.isToken) {
    login();
    return;
  }
  showGiftCode.value = true;
}

function closeGiftCode() {
  showGiftCode.value = false;
  giftCodeValue.value = "";
}

function handleClaim() {
  if (!giftCodeValue.value || giftCodeLoading.value) return;
  giftCodeLoading.value = true;
  $api.user.handleKaMiRecharge({
    card: (giftCodeValue.value || '').replace(/\s+/g, ''),   // [FIX-CARD] 去掉粘贴带来的空白字符
    client_id: localStorage.getItem('ga4_client_id')
  }).then((res) => {
    if (res.code == 200) {
      closeGiftCode();
      u.getUserInfo();
    } else {
      proxy.$notice("f", {desc: res.message || "Failed"});
    }
  }).catch(() => {
    proxy.$notice("f", {desc: "Network error"});
  }).finally(() => {
    giftCodeLoading.value = false;
  });
}

//前往用户中心
function toMine() {
  // router.push("user");
  router.push({name: "user"});
}

//前往银行
function toBank() {
  router.push({name: "bank"});
}

//显示登录弹框
function login() {
  loginModal(
      {visible: true, title: $t("loginLarge"), contentType: "def"},
      (callnack) => {
        // console.log('未登录 弹登录框');
        callnack();
      }
  );
}

//退出登录
function logout() {
  u.logout();
  if (u.sandbox) {
    router.push("/sandbox");
  } else {
    router.push("/");
  }
}

const isShowUserCard = ref(false);
const accountRef = ref(null);
watch(
    () => isShowUserCard.value,
    () => {
      if (isShowUserCard.value) {
        console.log("---");
        // gsap.fromTo(
        //   ".user-card",
        //   {
        //     top: "-0.8rem",
        //   },
        //   {
        //     top: "0.2rem",
        //     duration: 0.3,
        //     ease: "power3.inOut",
        //   }
        // );
        gsap.from(".user-card", {
          top: "-0.8rem",
          duration: 0.3,
        });
      }
    }
);
onMounted(() => {
  document.addEventListener("scroll", (e) => {
    // 获取当前滚动位置
    const scrollTop = window.scrollY;
    //获取dom边界信息
    // console.log('oo;',accountRef.value.offsetTop);
    if (!accountRef.value?.offsetTop) {
      return;
    }
    const initialOffsetTop = accountRef?.value?.offsetTop + 20;
    const userCard = document.querySelector(".user-card");
    // console.log("scrollTop:", scrollTop, "initialOffsetTop:", initialOffsetTop);
    //判断是否在可视区域
    if (scrollTop > initialOffsetTop) {
      isShowUserCard.value = true;
      console.log("显示用户卡片");
    } else {
      isShowUserCard.value = false;
      userCard && (userCard.style.top = ".2rem");
    }
  });
});
onBeforeUnmount(() => {
  proxy.$EventBus.all.clear();
});
</script>
<style lang="scss" scoped>
@import "./index.scss";

.cls-1 {
  fill: #647284;
  fill-rule: evenodd;
}

//自定义组件样式
:global(.ant-dropdown-menu) {
  border: 1px solid #262d40;

  width: 2.2rem;
  // height: 2.2rem;
  // max-height: 270px;
  // B方案（2026-10-15）：限高约10行，剩余保留滚动。
  // 注：不能用rem——行高里有AntD的固定px部分（菜单项padding、国旗图自然尺寸），
  // 行高不随rem线性缩，窄窗口下5.2rem只能露出4行（实测211px）。改用vh，随视口走。
  max-height: 62vh;
  overflow-x: hidden;
  overflow-y: scroll;
  font-size: 0.14rem;
  background-color: $app-bg-color !important;
  // @extend .fw4;
  // @extend .fz14;
}

:global(.ant-dropdown-menu-item-selected, .ant-dropdown-menu-submenu-title-selected) {
  background-color: $app-bg-color !important;
}

:deep(.ant-dropdown-menu-item) {
  color: #6c748a !important;
  @extend .fw4;
  @extend .fz14;

  .ant-dropdown-menu-title-content {
    border: none;
  }

  .lang-item {
    display: flex;
    align-items: center;
    margin-left: 0.1rem;
    margin-right: 0.2rem;
    padding: 0;
    // width: 190px;
    // height: 50px;
    width: 1.9rem !important;
    height: 0.5rem !important;
    text-transform: uppercase;
    border-bottom: 1px solid #262d40;

    img {
      margin-right: 0.21rem;
    }

    span {
      color: #6c748a;
      @extend .fw4;
      @extend .fz14;
    }
  }
}

.ant-dropdown-menu-item:last-child {
  // border: 2px solid yellow;
  .lang-item {
    border-bottom: 2px solid transparent;
  }
}

//u全局提示
:global(.ant-notification) {
  // border: 2px solid red;
}

:global(.ant-notification-notice) {
  // [FIX 2026-10-15] 必须 !important：AntD 自带 .ant-notification-notice 也有 overflow:hidden
  // （圆角用），两条权重相同、谁在后面谁生效；antd 改按需引入后该组件样式由运行时注入，
  // 顺序反超本条 ⇒ 框外那半个图标会被裁掉（设计是「图标一半在框外显示」）。
  // ⚠️ 不要删掉 !important，也不要改回 hidden。
  overflow: visible !important;
  min-height: 100px;
  border-radius: 5px;
  // width: max-content;
  // border: 2px solid rgb(103, 238, 69);
  font-size: 14px;
  font-weight: 400;
  color: #ffffff;
  padding: 16px 24px 16px 0;

  //success
  // background: linear-gradient(90deg, #2f1117 0%, #1b2031 100%);
  //fail
  // background: linear-gradient(90deg, #112F15 0%, #1B2031 100%);
}

:global(.ant-notification-notice-message) {
  //QUES  why 在内部不能获取样式,必须提出到外部global
  font-size: 16px;
  font-weight: bold;
  //success
  // color: #3fd03b;
  //fail
  // color: #d03b68;
}

//自定义icon
:global(.ant-notification-notice-icon) {
  left: 0;
  top: 50%;
  transform: translate(-60%, -50%);
}

//关闭icon
:global(.ant-notification-notice-close) {
  color: #ffffff;

  :hover {
    color: #ffffff !important;
  }
}

/* ======================================
   语言选择器懒加载优化 - 加载状态样式
   ====================================== */

// 语言选择器加载状态
.langrage-inner {
  position: relative;

  &.is-loading {
    opacity: 0.6;
    cursor: not-allowed;
    pointer-events: none;
  }
}

// 加载动画
.lang-loading-spinner {
  position: absolute;
  top: 50%;
  right: -24px;
  transform: translateY(-50%);
  width: 16px;
  height: 16px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-top: 2px solid #ffffff;
  border-radius: 50%;
  animation: lang-spin 0.8s linear infinite;
}

@keyframes lang-spin {
  0% { transform: translateY(-50%) rotate(0deg); }
  100% { transform: translateY(-50%) rotate(360deg); }
}

// 待释放金额 tooltip
:global(.coin-tooltip) {
  font-size: 0.13rem;
  color: #ffffff;
  white-space: nowrap;
}

:global(.ant-tooltip-inner) {
  background-color: #1a2030 !important;
  border-radius: 0.08rem !important;
  padding: 0.08rem 0.12rem !important;
}

// 资金行横排布局
.funds-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.1rem;
}

// 淡入淡出动画
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s;
}

.fade-enter-from, .fade-leave-to {
  opacity: 0;
}

// 禁用状态的菜单项
:deep(.ant-dropdown-menu-item-disabled) {
  cursor: not-allowed !important;
  opacity: 0.5;

  .lang-item {
    pointer-events: none;
  }
}

// === Gift Code 按钮 ===
.gift-code-btn {
  width: 0.48rem;
  height: auto;
  cursor: pointer;
  margin-right: 0.12rem;
  transition: transform 0.2s;
  &:hover {
    transform: scale(1.1);
  }
}

// === 游客态 gift code + login 按钮容器 ===
.guest-account {
  display: flex;
  align-items: center;
}
</style>

<style lang="scss">
// === Gift Code 弹窗（全局样式，因为 myModal 通过 portal 渲染） ===
.gift-code-modal {
  .ant-modal-body {
    padding: 0 !important;
  }
  .gift-code-container {
    text-align: center;
    padding: 0.4rem 0.3rem 0.3rem;
    position: relative;
  }
  .gift-code-title {
    font-size: 0.24rem;
    font-weight: bold;
    color: #fff;
    letter-spacing: 0.02rem;
  }
  .gift-code-subtitle {
    color: #676A76;
    font-size: 0.14rem;
    margin: 0.08rem 0 0.25rem;
  }
  .gift-code-input-wrap {
    margin-bottom: 0.25rem;
  }
  .gift-code-input {
    background: transparent;
    border: none;
    border-bottom: 1px solid #2a3148;
    border-radius: 0;
    color: #fff;
    text-align: center;
    font-size: 0.16rem;
    padding-left: 0;
    padding-right: 0;
    outline: none;
    box-shadow: none !important;
    &:focus {
      border-bottom-color: $active-color;
      box-shadow: none !important;
    }
    &::placeholder {
      color: #3d4561;
    }
  }
  .gift-code-claim {
    min-width: 1.6rem;
    height: 0.4rem;
    background-color: #e60046;
    color: #fff;
    border: none;
    border-radius: 0.2rem;
    font-size: 0.14rem;
    font-weight: bold;
    cursor: pointer;
    &:hover:not(:disabled) {
      background-color: #ff1a5e !important;
    }
    &:disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }
  }
}
</style>